/**
 * Voice substitution engine for trading-specific speech corrections.
 * Merges hardcoded defaults with user-configurable custom rules from settings.
 */

// Escape special regex characters in user-provided strings
const escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Default substitutions (always applied after custom rules)
const DEFAULTS = [
  // Trading terms Windows Voice Typing commonly mangles
  { from: /\bvic[ks]s?\b/gi, to: 'VIX' },              // "vicks"/"vics" → "VIX"
  { from: /\bview\s*up\b/gi, to: 'VWAP' },              // "view up" → "VWAP"
  { from: /\bBMA\b/g, to: 'EMA' },                      // "BMA" → "EMA"
  { from: /\b(?:chubby|stroppy)\b/gi, to: 'Choppy' },   // "chubby"/"stroppy" → "Choppy"
  { from: /\bcrosstown\b/gi, to: 'Cross Down' },         // "crosstown" → "Cross Down"
  // Formatting helpers
  { from: /(\d)\s+to\s+(\d)/gi, to: '$1-$2' },          // "26 to 30" → "26-30"
  { from: /(\S)\s+dash\s+(\S)/gi, to: '$1-$2' },        // "21 dash 25" → "21-25"
];

/**
 * Apply voice substitutions to text.
 * @param {string} text - Raw speech transcript
 * @param {Array<{from: string, to: string}>} customRules - User-defined rules from settings
 * @returns {string} Corrected text
 */
export function applyVoiceSubs(text, customRules = []) {
  let result = text;

  // Apply user's custom rules first (higher priority)
  for (const rule of customRules) {
    if (!rule.from || rule.to == null) continue;
    try {
      result = result.replace(new RegExp(`\\b${escapeRegex(rule.from)}\\b`, 'gi'), rule.to);
    } catch (e) {
      // Skip malformed patterns
    }
  }

  // Then apply hardcoded defaults
  for (const { from, to } of DEFAULTS) {
    result = result.replace(from, to);
  }

  return result;
}
